import styled from 'styled-components';

export const CarouselRoot = styled.div<{ $hoverScale: number }>`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &:hover img,
  &:hover video {
    transform: ${({ $hoverScale }) =>
      $hoverScale > 1 ? `scale(${$hoverScale})` : 'none'};
  }
`;

export const CarouselTrack = styled.div<{
  $renderIndex: number;
  $transitionEnabled: boolean;
}>`
  display: flex;
  width: 100%;
  height: 100%;
  transform: translateX(${({ $renderIndex }) => `-${$renderIndex * 100}%`});
  transition: ${({ $transitionEnabled }) =>
    $transitionEnabled ? 'transform 500ms ease' : 'none'};
`;

export const CarouselSlide = styled.div`
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const CarouselImage = styled.img<{ $objectFit: 'cover' | 'contain' }>`
  width: 100%;
  height: 100%;
  object-fit: ${({ $objectFit }) => $objectFit};
  transition: transform 300ms ease;
  display: block;
`;

export const CarouselVideo = styled.video<{ $objectFit: 'cover' | 'contain' }>`
  width: 100%;
  height: 100%;
  object-fit: ${({ $objectFit }) => $objectFit};
  transition: transform 300ms ease;
  display: block;
`;

export const CarouselIndicators = styled.div`
  position: absolute;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 2;
`;

export const CarouselIndicator = styled.span<{ $active: boolean }>`
  width: ${({ $active }) => ($active ? '18px' : '6px')};
  height: 6px;
  border-radius: 999px;
  background-color: ${({ theme, $active }) =>
    $active ? theme.primary : 'rgba(255, 255, 255, 0.5)'};
  transition: 200ms ease;
`;

export const CarouselNavigationButton = styled.button<{
  $left?: boolean;
  $right?: boolean;
}>`
  position: absolute;
  top: 50%;
  ${({ $left }) => ($left ? 'left: 12px;' : '')}
  ${({ $right }) => ($right ? 'right: 12px;' : '')}
  transform: translateY(-50%);
  z-index: 3;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: ${({ theme }) => theme.neutral0};
  cursor: pointer;
  transition: background 200ms ease, opacity 200ms ease, filter 200ms ease;

  &:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.7);
    filter: brightness(1.08);
  }

  &:disabled {
    opacity: 0.45;
    cursor: default;
  }
`;
